stripLeadingSlash